import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { baseComponents } from '~components/markdown';
import { useMeta } from '~store/meta';
import trimHttps from '~utils/trim-https';
import { Box, Container, Heading, Link, List, ListItem, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { NextSeo } from 'next-seo';
import { Image } from 'react-datocms';
import ReactMarkdown from 'react-markdown';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var AboutPage = function(props) {
    var ref8, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var data = props.data;
    var meta = useMeta();
    var socials = (ref8 = meta.about) === null || ref8 === void 0 ? void 0 : ref8.socials;
    var pageMeta = {
        title: 'About me',
        description: 'Get to know more about myself'
    };
    return(/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(NextSeo, _objectSpread({}, pageMeta)),
            /*#__PURE__*/ _jsxs(Container, {
                maxW: "4xl",
                p: [
                    4,
                    8
                ],
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        pb: 8,
                        children: /*#__PURE__*/ _jsx(Image, {
                            data: (ref1 = data.about) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.responsiveImage
                        })
                    }),
                    /*#__PURE__*/ _jsx(Stack, {
                        lineHeight: "tall",
                        pb: 8,
                        spacing: 4,
                        children: /*#__PURE__*/ _jsx(ReactMarkdown, {
                            children: (ref3 = data.about) === null || ref3 === void 0 ? void 0 : ref3.preface,
                            components: baseComponents
                        })
                    }),
                    /*#__PURE__*/ _jsx(SimpleGrid, {
                        columns: [
                            2,
                            3,
                            4
                        ],
                        gap: 4,
                        children: (ref4 = data.about) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.knowledges) === null || ref5 === void 0 ? void 0 : ref5.map(function(item) {
                            var ref;
                            return item && /*#__PURE__*/ _jsxs(Box, {
                                children: [
                                    /*#__PURE__*/ _jsx(Heading, {
                                        pb: 4,
                                        size: "md",
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ _jsx(List, {
                                        fontSize: "sm",
                                        spacing: 1,
                                        children: (ref = item.entries) === null || ref === void 0 ? void 0 : ref.split(', ').map(function(e, i) {
                                            /*#__PURE__*/ return _jsx(ListItem, {
                                                children: e.trim()
                                            }, i);
                                        })
                                    })
                                ]
                            }, item.title);
                        })
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        color: "whiteAlpha.400",
                        py: 8,
                        children: "\xb7 \xb7 \xb7"
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        pb: 2,
                        children: [
                            "You can reach out via email at",
                            ' ',
                            /*#__PURE__*/ _jsx(Link, {
                                href: "mailto:".concat((ref6 = meta.about) === null || ref6 === void 0 ? void 0 : ref6.email),
                                variant: "link",
                                children: (ref7 = meta.about) === null || ref7 === void 0 ? void 0 : ref7.email
                            }),
                            ", or via socials below:"
                        ]
                    }),
                    /*#__PURE__*/ _jsx(List, {
                        spacing: 1,
                        children: Object.entries(socials).map(function(param) {
                            var _param = _slicedToArray(param, 2), name = _param[0], href = _param[1];
                            /*#__PURE__*/ return _jsxs(ListItem, {
                                children: [
                                    name,
                                    " -",
                                    ' ',
                                    /*#__PURE__*/ _jsx(Link, {
                                        href: href,
                                        isExternal: true,
                                        variant: "link",
                                        children: trimHttps(href)
                                    })
                                ]
                            }, name);
                        })
                    })
                ]
            })
        ]
    }));
};
export var __N_SSG = true;
export default AboutPage;
